export default "__VITE_ASSET__CZBWLiVD__"